<div class="fundo" align="center">
  {{ nomeSistema }}
</div>